export default __webpack_public_path__ + "6f1c0e2b0444bb2669d2272004c92ba7.svg";